export function maskString(value: string | null | undefined, visibleStart = 4, visibleEnd = 0): string {
  if (!value?.trim()) return '—';
  const v = value.trim();
  if (v.length <= visibleStart + visibleEnd) return '••••••••';
  const end = visibleEnd > 0 ? v.slice(-visibleEnd) : '';
  return `${v.slice(0, visibleStart)}${'•'.repeat(8)}${end}`;
}

export function maskIp(ip: string | null | undefined): string {
  if (!ip?.trim()) return '—';
  const parts = ip.trim().split('.');
  if (parts.length === 4) return `${parts[0]}.${parts[1]}.•••.•••`;
  return maskString(ip, 3);
}
